// preloader handler

HTMLDocument.prototype.ready = () => {
    return new Promise((resolve) => {
        if (document.readyState === 'complete') {
            return resolve(document);
        }

        document.addEventListener('DOMContentLoaded', () => {
            resolve(document);
        })
    });
};

// define app

class Irs {
    constructor(serviceHost) {
        this.serviceHost = serviceHost;
        this.pathFetchBySource = '/1.0/fetch/source/{sourceId}';
        this.pathFetchByToken = '/1.0/fetch/token/{token}';
        this.pathCreate = '/1.0/create/{pool}';
    }

    fetchBySource(sourceId) {
        let url = this.buildUrl('fetch').replace('{sourceId}', sourceId);

        if (url) {
            let request = new Request(url);

            return fetch(request)
                .then((response) => response.json())
                .then((response) => {
                    if ('token' in response.data) {
                        return response;
                    }

                    let error = new Error('source does not exist');
                    error.response = response;

                    throw error;
                })
        }
    }

    create(pool, params) {
        let url = this.buildUrl('create').replace('{pool}', pool);

        if (url) {
            let request = new Request(url, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: atob(params)
            });

            return fetch(request)
                .then((response) => response.json())
                .then((response) => {
                    if ('token' in response.data) {
                        return response;
                    }

                    let error = new Error('could not create image');
                    error.response = response;

                    throw error;
                })
        }
    }

    pollForImage(token, elm, timeout, interval) {
        let endTime = Number(new Date()) + (timeout || 5000);
        interval = interval || 1000;

        let checkCondition = (resolve, reject) => {
            let url = this.buildUrl('pollForImage').replace('{token}', token);

            if (url) {
                fetch(new Request(url))
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.data.cdn.url_cdn !== null) {
                            resolve(response);
                        }
                        else if (Number(new Date()) < endTime) {
                            setTimeout(checkCondition, interval, resolve, reject);
                        }
                        else {
                            reject(new Error('timeout: cdn wasnt set in time'));
                        }
                    });
            }
        };

        return new Promise(checkCondition);
    }

    buildUrl(type) {
        let path = null;

        switch (type) {
            case 'fetch':
                path = this.pathFetchBySource;
                break;
            case 'create':
                path = this.pathCreate;
                break;
            case 'pollForImage':
                path = this.pathFetchByToken;
                break;
        }

        if (path !== null) {
            return this.serviceHost.replace(/\/$/, '') + path;
        }

        return null;
    }
}

// kick off app

document.ready().then(() => {
    let elms = document.querySelectorAll('.irs-item');

    if (elms.length === 0) {
        document.dispatchEvent(
            new CustomEvent('irs:none') // nothing to process
        )
    }

    elms.forEach((elm) => {
        const irs = new Irs(elm.dataset.serviceHost);
        let dataset = elm.dataset;
        let delayEndTime = Number(new Date()) + dataset.delay * 1000;

        let pollingCallback = (response) => {
            let img = new Image();
            let imageUrl = response.data.cdn.url;

            img.onload = () => {
                let resultElm = elm.querySelector('.result');
                let resultImage = resultElm.querySelector('.irs-image');
                resultImage.setAttribute('src', imageUrl);
                resultElm.parentElement.classList.add('loaded');

                // trigger complete event

                document.dispatchEvent(
                    new CustomEvent('irs:complete:' + dataset.sourceId)
                )
            };

            let callback = () => {
                img.src = imageUrl;
            };

            let delayRestTime = 0;
            let delayNowTime = Number(new Date());

            if (delayNowTime < delayEndTime) {
                delayRestTime = delayEndTime - delayNowTime;
            }

            setTimeout(callback, delayRestTime);
        };

        let handleSuccessfulResponse = (response) => {
            return irs.pollForImage(response.data.token, elm).then(pollingCallback); // pollForImage until cdn image or timeout hits
        };

        let createCallback = () => {
            irs.create(dataset.pool, dataset.params)
                .then(handleSuccessfulResponse)
                .catch((error) => {
                    document.dispatchEvent(
                        new CustomEvent('irs:error:' + dataset.sourceId, {message: error})
                    );
                })
        };

        irs.fetchBySource(dataset.sourceId)
            .then(handleSuccessfulResponse)
            .catch(createCallback);
    });
});